<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <template>
        <UserDataFirmForm
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import UserDataFirmForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('userdatafirm/create')

export default {
  components: {
    UserDataFirmForm,
    Loader
  },

  props: {
    userIRI: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      routeName: '',
      item: {
        isContactPerson: 0,
        vatInvoiceRecipient: 0,
        employeePosition: ''
      }
    }
  },

  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  created () {
    this.routeName = this.$route.name
    if (this.userIRI) {
      this.item.employee = this.userIRI
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
